import React from 'react'
import PropTypes from 'prop-types'
import StyledText from '#components/a/StyledText'
import SystemIcon from '#components/a/SystemIcon'
import i18n from "i18next";

function SystemMessageBenachrichtigung({userInfo, message, onNotificationClick}) {
  const redirectAndMarkAsRead = () => {
    onNotificationClick()
    window.open(i18n.t('external_url_support'));
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className="notification urgent"
      onClick={() => redirectAndMarkAsRead()}
      onKeyPress={() => redirectAndMarkAsRead()}
    >
      <SystemIcon />
      <StyledText text={message} modifier="notification message" />
    </div>
  )
}

export default SystemMessageBenachrichtigung

SystemMessageBenachrichtigung.propTypes = {
  message: PropTypes.string,
  onNotificationClick: PropTypes.func.isRequired,
}
